import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { type LinkProps as RouterLinkProps, Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

import { buttonVariants } from './button';

export interface LinkProps extends RouterLinkProps, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const PSLink = React.forwardRef<HTMLAnchorElement, LinkProps>(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : Link;
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});

PSLink.displayName = 'PSLink';

export { PSLink };
